import type { GradingKnowledgeBaseAdherence } from "@repo/app-types/entities/knowledgeBaseAdherence";
import type { AccountGradingRecording } from "@repo/app-types/entities/teammatePerformanceSummary";
import type { FC } from "react";
import { useCallback } from "react";
import { useModalNavigation } from "../../hooks/useModalNavigation.js";
import { KnowledgeBaseAdherenceStatementsCard } from "./knowledgeBaseAdherenceStatementsCard.js";

export interface KnowledgeBaseAdherenceStatementsCardContainerProps {
  recordings?: readonly AccountGradingRecording[];
  knowledgeBaseAdherence: GradingKnowledgeBaseAdherence | null | undefined;
}

export const KnowledgeBaseAdherenceStatementsCardContainer: FC<
  KnowledgeBaseAdherenceStatementsCardContainerProps
> = (props) => {
  const modalNavigation = useModalNavigation();
  const handleStatementSelect = useCallback(
    (statementIndex: number) => {
      modalNavigation.push(
        `knowledge-base-adherence/${encodeURIComponent(String(statementIndex))}`,
      );
    },
    [modalNavigation],
  );

  return (
    <KnowledgeBaseAdherenceStatementsCard
      recordings={props.recordings}
      knowledgeBaseAdherence={props.knowledgeBaseAdherence}
      onStatementClick={handleStatementSelect}
    />
  );
};
